import EventTimingStatus from './_event-timing-status.js'
import MiniScoreboard from './_mini-scoreboard.js'
import Participants from './_participants.js'
import Text from './_text.js'
import Image from './_image.js'

export default {
  name: 'MiniEventItemContent',
  values: {
    eventTimingStatus: {
      configSet: EventTimingStatus,
      configValues: {},
    },
    scoreboard: {
      configSet: MiniScoreboard,
      configValues: {
        padding: '0 0 0 5px',
        allowAmericanLayout: false,
        stretch: true,
      },
    },
    participants: {
      configSet: Participants,
      configValues: {
        container: {
          itemSpacing: '4px',
        },
      },
    },
    eventNameLabel: {
      configSet: Text,
      configValues: {
        truncate: true,
        ellipsisOnLineNumber: 3,
      },
    },
    icon: {
      configSet: Image,
      configValues: {
        src: 'controls-chevron-standard-right',
        style: {
          width: '8px',
          height: '8px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
